export type TagValue = {
  readonly key: string;
  readonly value: string;
};

// Global symbol, not a class: the SDK can load from two module paths, which breaks instanceof.
const TAG_VALUE = Symbol.for("@listen-labs/o11y/TagValue");

export const isTagValue = (value: unknown): value is TagValue =>
  typeof value === "object" && value !== null && TAG_VALUE in value;

export class Tag {
  constructor(readonly key: string) {
    if (key.length === 0) {
      throw new Error("Metric tag key cannot be empty");
    }
  }

  withValue(value: string): TagValue {
    return Object.defineProperty({ key: this.key, value }, TAG_VALUE, {
      value: true,
    });
  }
}

/** Unique by key; later groups override earlier ones. */
export const mergeTags = (
  ...groups: readonly (readonly TagValue[])[]
): readonly TagValue[] =>
  Array.from(new Map(groups.flat().map((tag) => [tag.key, tag])).values());
